import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        "m2Sidebar": m2Sidebar
    },
    data() {
        return {
            subject_group: [],
            choose_subject: [],
            choose_subject_ids: [],
            pay_switch_status: '',
            rule: []
        }
    },
    methods: {
        getSubject() {
            this.$http.get(globalProvider.serviceUrl('e_reg/g/asubs/{reg_id}'), {
                params: {
                    reg_id: this.$store.state.examRegInfo.examRegInfo.exam_registration_id,
                }
            }).then((data) => {
                if (data.body.code === resultCode.Success) {
                    this.pay_switch_status = this.$store.state.examRegInfo.examRegInfo.pay_switch_status;
                    this.rule = data.body.data.subject_rules;
                    this.subject_group = data.body.data.subject_data.compulsory_group.concat(data.body.data.subject_data.optional_group);
                    if (this.subject_group.length == 0) {
                        this.$alert('无可增加科目', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$router.push({
                                    name: 'default_myRegister'
                                })
                            }
                        });
                    }
                }
            });
        },
        chooseSubject: function (e, item) {
            if (this.choose_subject_ids.indexOf(item.subject_id) != -1) {
                this.choose_subject.splice(this.choose_subject_ids.indexOf(item.subject_id), 1);
                this.choose_subject_ids.splice(this.choose_subject_ids.indexOf(item.subject_id), 1);
            } else {
                if (this.rule[item.subject_id]) {
                    if (this.rule[item.subject_id].length > 0) {
                        let list = [];
                        this.choose_subject.forEach((n) => {
                            for (let i in this.rule[item.subject_id]) {
                                if (n.subject_id == this.rule[item.subject_id][i]) {
                                    list.push(this.choose_subject.indexOf(n))
                                }
                            }
                        })
                        list.reverse();
                        for (let item in list) {
                            this.choose_subject.splice(list[item], 1)
                            this.choose_subject_ids.splice(list[item], 1)
                        }
                    }
                }
                this.choose_subject.push(item);
                this.choose_subject_ids.push(item.subject_id);
            }
        },
        beSelected: function (item) {
            if (this.choose_subject_ids.indexOf(item.subject_id) != -1) {
                return true
            } else {
                return false
            }
        },
        save() {
            if (this.choose_subject.length > 0) {
                this.$http.post(globalProvider.serviceUrl('e_reg/u/sa'), {
                    reg_id: this.$store.state.examRegInfo.examRegInfo.exam_registration_id,
                    subject_ids: this.choose_subject_ids,
                }).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.getReg(data.body.data)
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
            } else {
                this.$alert('请选择至少一个科目', {
                    confirmButtonText: '确定',
                });
            }
        },
        getReg(reg_id) {
            let reg_info_operation = 2;
            this.$http.get(globalProvider.serviceUrl('e_reg/g/eri/{reg_id}/{reg_info_operation}'), {
                    params: {
                        reg_id: reg_id,
                        reg_info_operation: reg_info_operation
                    }
                })
                .then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setExamRegInfo', data.body.data);
                        if (data.body.data.pay_switch_status) {
                            this.$router.push({
                                name: 'default.examReg.payOrder'
                            });
                        } else {
                            this.$router.push({
                                name: 'default_myRegister'
                            });
                        }

                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                })
        },
    },
    created: function () {
        this.pay_switch_status = this.$store.state.examRegInfo.examRegInfo.pay_switch_status;
        this.$store.commit('setHeaderState', '3');
        this.getSubject();
    }
}